package com.wintermar.inspection.feature.util.finding_category

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.util.toTitleCase
import com.wintermar.inspection.graphql.type.FindingCategory
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.finding_category_description
import org.jetbrains.compose.resources.stringResource

@Composable
fun FindingCategory.toVariant(): FindingCategoryModel {
    val themeColor = LocalAppTheme.current.color

    val content = when (this) {
        FindingCategory.OBSERVATION -> FindingCategoryModel(
            color = themeColor.surface.accent.blue.medium.default,
            label = this.name.toTitleCase(),
            description = stringResource(Res.string.finding_category_description, "90")
        )

        FindingCategory.MINOR_NC -> FindingCategoryModel(
            color = themeColor.surface.accent.yellow.medium.default,
            label = "Minor NC",
            description = stringResource(Res.string.finding_category_description, "30")
        )

        FindingCategory.MAJOR_NC -> FindingCategoryModel(
            color = themeColor.surface.accent.red.medium.default,
            label = "Major NC",
            description = stringResource(Res.string.finding_category_description, "7")
        )

        FindingCategory.UNKNOWN__ -> FindingCategoryModel()
    }

    return remember(this, themeColor) {
        content
    }
}
